import {CustomSpineAnimation} from "./CustomSpineAnimation";

export class CardHighlightAnimation extends CustomSpineAnimation {

    private static readonly ANIMATION_CONFIG = {
        NAME: "doubleUpCurrentCardHighlight",
        STATES: {
            GLOW: "glow",
        },
    };

    constructor() {
        super(CardHighlightAnimation.ANIMATION_CONFIG.NAME);
        this.play(CardHighlightAnimation.ANIMATION_CONFIG.STATES.GLOW, true);
    }

}



// WEBPACK FOOTER //
// ./src/app/CardHighlightAnimation.ts